import pageType from 'Addons/search/pageType.ts';
import { mainConfig } from 'Models/uiConfig/componentlessWidgetsConfig.ts';
import defaultProductConfig from 'Platforms/shopify/productConfig.js';
import uiConfig from './uiConfig.js';

const { product: { getItemId: getItemIdCustom, priceFormatter: priceFormatterCustom, ...config } = {} } =
  mainConfig;

const commonFields = ['id', 'image', 'title', 'url'];
const defaultFields = commonFields.reduce((fields, name) => {
  const errorMessage = `${name} field is missing in productConfig`;
  fields[name] = { toString: () => console.error(errorMessage) };
  return fields;
}, {});

const {
  getItemId: getItemIdDefault,
  priceFormatter: priceFormatterDefault,
  ...defaults
} = defaultProductConfig;

const fields = {
  key: '_docid',
  ...(defaults.fields || defaultFields),
  ...(config.fields || {}),
};

const localItemId =
  uiConfig.pageType === pageType.product
    ? getItemIdCustom
      ? getItemIdCustom({ getItemId: getItemIdDefault, getVariantId: defaults.getVariantId })
      : (getItemIdDefault?.() ?? '')
    : '';

// create new function instead of passing priceFormatter.format itself
// to prevent bugs if format() would depend on this
const priceFormatter =
  priceFormatterCustom ||
  priceFormatterDefault ||
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
const formatPrice = (price) => (price ? priceFormatter.format(price) : '');

const productConfig = {
  localItemId,
  entityIdField: 'id',
  formatPrice,
  noImageSrc: 'https://client.convermax.com/static/img/noimage.png',
  ...defaults,
  ...config,
  fields,
};

window.Convermax.templates.config.productConfig = productConfig;
export default productConfig;
